import { Suspense, lazy } from 'react';
import './RobotSpline.css';

const Spline = lazy(() => import('@splinetool/react-spline'));

const ROBOT_SCENE = "https://prod.spline.design/PyzDhpQ9E5f1E3MT/scene.splinecode";

export default function RobotSpline() {
  return (
    <div className="robot-spline-wrap">
      <Suspense fallback={
        <div className="robot-spline-loading">
          <div className="robot-spline-spinner" />
        </div>
      }>
        <Spline
          scene={ROBOT_SCENE}
          className="robot-spline"
        />
      </Suspense>

      {/* Covers the Spline watermark in bottom-right */}
      <div className="robot-watermark-cover" />

      {/* Edge fades */}
      <div className="robot-fade robot-fade-top" />
      <div className="robot-fade robot-fade-bottom" />
      <div className="robot-fade robot-fade-left" />
      <div className="robot-fade robot-fade-right" />
    </div>
  );
}